const categoryMenu = [
  { to: "newArrival", name: "New Arrival" },
  { to: "computers", name: "Computers" },
  { to: "camers_audio_videio", name: "Cameras, Audio, Videio" },
  { to: "mobiles&tabletes", name: "Mobiles & Tablets" },
  { to: "tv", name: "Tv & Audio" },
  { to: "watch", name: "Watches" },
  { to: "accessories", name: "Accessories" },
];
export default categoryMenu;
